import { Injectable } from "@angular/core";
import Auth, { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
//import Auth, { CognitoHostedUIIdentityProvider, CognitoAccessToken } from '@aws-amplify/auth';
import { Hub, ICredentials } from "@aws-amplify/core";
import { Subject, Observable } from "rxjs";
import { CognitoUser } from "amazon-cognito-identity-js";

export interface NewUser {
  email: string;
  phone: string;
  password: string;
  firstName: string;
  lastName: string;
  userid: string;
}

@Injectable({
  providedIn: "root"
})
export class AuthService {
  public loggedIn: boolean;
  private _authState: Subject<CognitoUser | any> = new Subject<
    CognitoUser | any
  >();
  authState: Observable<CognitoUser | any> = this._authState.asObservable();

  public static SIGN_IN = "signIn";
  public static SIGN_OUT = "signOut";
  public static FACEBOOK = CognitoHostedUIIdentityProvider.Facebook;
  public static GOOGLE = CognitoHostedUIIdentityProvider.Google;

  constructor() {
    Hub.listen("auth", data => {
      const { channel, payload } = data;
      if (channel === "auth") {
        this._authState.next(payload.event);
      }
    });
  }

  signUp(user: NewUser): Promise<CognitoUser | any> {
    return Auth.signUp({
      username: user.email,
      password: user.password,
      attributes: {
        email: user.email,
        given_name: user.firstName,
        family_name: user.lastName,
        phone_number: user.phone,
        nickname: user.userid
      }
    });
  }

  signIn(username: string, password: string): Promise<CognitoUser | any> {
    return new Promise((resolve, reject) => {
      Auth.signIn(username, password)
        .then((user: CognitoUser | any) => {
          this.loggedIn = true;
          resolve(user);
        })
        .catch((error: any) => reject(error));
    });
  }

  signOut(): Promise<any> {
    return Auth.signOut().then(() => (this.loggedIn = false));
  }

  socialSignIn(
    provider: CognitoHostedUIIdentityProvider
  ): Promise<ICredentials> {
    return Auth.federatedSignIn({
      provider: provider
    });
  }

  async getCognitoAuthToken() {
    // let test = await Auth.currentCredentials();
    // console.log (test.sessionToken);
    let test = await Auth.currentSession();
    //console.log(test.getIdToken()['jwtToken']);
    return test.getIdToken()["jwtToken"];
  }
}
